import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DownloadExcelComponent } from 'src/app/module/shared/components/download-excel/download-excel.component';
import { ViewEditCommonComponent } from 'src/app/module/shared/components/view-edit-common/view-edit-common.component';
import { AccessControlService } from 'src/app/shared/services/AccessControl.service';
import { TabService } from 'src/app/shared/tab.service';
import { AddordersComponent } from '../add-orders/add-orders.component';
import { CommonBulkPrintComponent } from 'src/app/module/shared/components/common-bulk-print/common-bulk-print.component';
import { CommonCsvComponent } from 'src/app/module/shared/components/common-csv/common-csv.component';
import { Observable } from 'rxjs';
import { ordersService } from '../../services/orders.service';

@Component({
  selector: 'app-draft-orders',
  templateUrl: './draft-orders.component.html',
  styleUrls: ['./draft-orders.component.css']
})
export class draftOrdersComponent {
  theme = 'dark'
  pageSize = 100; // Number of items per page
  pageIndex = 0;
  currentPage: number = 0;
  pageNumber = 0;
  sortingCol: string = 'id';
  direction: string = 'DESC'
  tableName = 'orderTable'
  warehouseFilter: any = [];
  warehouseData: any = [];
  getWarehouseList: any;
  customerModel: any;
  selectedWarehouse: any;
  storedWarehouse: any;
  clientId: any;
  clientDetails: any;
  ref: DynamicDialogRef | undefined;
  selectedData: any[] = [];
  editContation: boolean = false;
  // filters= [];
  filters: { key: string; value: any }[] = [];
  userType: any;
  columns = [
    // { showColumn: false, sortingColumn: '', key: '', header: 'Action', sortable: false, type: 'action', viewDialog: true, viewHistory: true, componentName: 'orders' },
    // { showColumn: false, sortingColumn: '', key: 'orderNumber', header: 'Order Id', sortable: false, type: 'text', viewDialog: true, viewHistory: true, componentName: 'orders' },
    // {showColumn: true, sortingColumn: '',  key: 'orderCode', header: ' Order Code ', sortable: false, type: 'text', viewDialog: false },
    // { showColumn: true, sortingColumn: '', key: 'jobCode', header: 'Order Number', sortable: false, viewDialog: true, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'accountName', header: 'Customer', sortable: false, type: 'text', viewDialog: false },
    { showColumn: true, sortingColumn: '', key: 'warehouseCode', header: 'Warehouse', sortable: false, type: 'text', viewDialog: false },
    // { showColumn: true, sortingColumn: '', key: 'customerWarehouseId', header: 'Warehouse', sortable: false, type: 'text' },
    // {showColumn: true, sortingColumn: '',  key: 'vendors', header: 'Vendor', sortable: false, type: 'text' },
    // {showColumn: true, sortingColumn: '',  key: 'headCountNeeded', header: 'Head Count', sortable: false, type: 'text' },
    // { showColumn: true, sortingColumn: '', key: 'status', header: 'Order Status', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'contactName', header: 'Contact Person', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'contactMobile', header: 'Contact Number', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'contactAlternateMobile', header: 'Contact Alternate Number', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'contactEmail', header: 'Contact Email', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'fromDate', header: 'Order From Date', sortable: false, type: 'invoicedate' },
    { showColumn: true, sortingColumn: '', key: 'toDate', header: 'Order To Date', sortable: false, type: 'invoicedate' },
    { showColumn: true, sortingColumn: '', key: 'remarks', header: 'Remark', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'districtName', header: 'Location', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'stateName', header: 'State', sortable: false, viewDialog: false, type: 'text' },
    {showColumn: true, sortingColumn: 'createdAt',  key: 'createdAt', header: 'Created At', sortable: true, type: 'date' },
    {showColumn: true, sortingColumn: '',  key: 'createdByName', header: 'Created By', sortable: false, type: 'text' },
    {showColumn: true, sortingColumn: 'updatedAt',  key: 'updatedAt', header: 'Updated At', sortable: true, type: 'date' },
    {showColumn: true, sortingColumn: '',  key: 'updatedByName', header: 'Updated By', sortable: false, type: 'text' },

  ];

  columnsToExport: string[] = ['financialYearId', 'budgetDate', 'budgetType', 'reference', 'accountName', 'warehouseName', 'approvedBudget', 'expense', 'createdAt', 'createdByName', 'updatedAt', 'updatedByName', 'budgetProof', 'remarks'];

  dropdownOptions: { [key: number]: string[] } = {
    0: ['2023-2024', '2022-2023'],
    1: ['January', 'February', 'March'],
  };

  warehouseList = []; // Define warehouse list here
  accounts = []; // Define account list here
  totalCount: any;
  @ViewChild(DownloadExcelComponent) downloadExcel!: DownloadExcelComponent;
  @ViewChild(CommonBulkPrintComponent) printData!: CommonBulkPrintComponent;
  @ViewChild(CommonCsvComponent) downloadCsv!: CommonCsvComponent;

  selectedRows: any[] = [];
  tableLists: any = [];
  user_details: any;
  constructor(private ordersService: ordersService,
    private primengConfig: PrimeNGConfig, private fb: FormBuilder, private tabService: TabService,
    public dialogService: DialogService, private messageService: MessageService, private router: Router, public accessControlService: AccessControlService) {
    this.getWarehouseList = JSON.parse(localStorage.getItem('wareHouseList')!)
    this.accounts = JSON.parse(localStorage.getItem('accountList')!)
    this.user_details = JSON.parse(localStorage.getItem('UserDetails')!);
    this.userType = this.user_details?.userType;
    this.primengConfig.ripple = true;
  }

  searchForm = this.fb.group({
    WAREHOUSE_ID_IN: new FormControl(''),
    ACCOUNT_ID_IN: new FormControl(''),
    // FC_NAME: new FormControl(''),
    STATUS: new FormControl(null)
  });

  ngOnInit(): void {
    this.getList()
  }

  getWarehouseDetails(pageIndex: number, pageSize: number, filter: any) {
    // const warehouseFilter = this.setFilter();
    this.warehouseData = []
    this.totalCount = 0
    // this.warehouseService.getWarehouseList(pageIndex, pageSize, filter).subscribe((res: any) => {
    //   this.warehouseData = res?.responseObject?.content;
    //   this.totalCount = res?.responseObject?.totalElements;
    // })
  }

  
  reloadEvent(event:any){
    console.log(event);
    this.getList()
  }

  getList() {
    console.log(this.filters)
    let postData: any[] = [];
    let vendorIds: string[] = [];
    let accountIds: any;

    if (this.user_details?.vendorMapping?.length > 0) {
      vendorIds = this.user_details.vendorMapping.map((el: any) => el.vendorId || el.id);
    }
    if (this.user_details?.accountMapping?.length > 0) {
      accountIds = this.user_details.accountMapping.map((el: any) => el.accountId || el.id);
    }
    
   let uniqueaccountIds = [...new Set(accountIds)].join(",");

    if (this.userType == 'ASSOCIATE') {
      postData = [
        {
          key: 'USER_ID_IN',
          value: this.user_details?.id
        },
      ];
    } else if (this.userType === 'VENDOR' && vendorIds.length > 0) {
      postData = [
        {
          key: 'VENDOR_ID_IN',
          value: vendorIds.join(',')
        },
        {
          key: 'ORDER_TYPE',
          value: 'Child'
        }

      ];
    } else {
      postData = [
        // {
        //   key: 'ORDER_TYPE',
        //   value: 'Parent'
        // },
        {
          key: 'ACCOUNT_ID_IN',
          value: uniqueaccountIds
        },  
      ];
    }
    // this.filters = [];

    //   if(this.filters.length < 1){
    //     const extractedIds = this.user_details;
    //     const valueString = extractedIds.join(',');
    //     this.filters = valueString
    // ? [
    //     {
    //       key: 'VENDOR_IN',
    //       value: valueString,
    //     }
    //   ]
    // : [];
    //     // this.filters = [{ key: "MAPPING_IN", value: valueString }];
    //   }
    this.filters = [...(this.filters || []), ...postData];

    this.filters = this.filters.filter(
      (item: any) =>
        (item.value && item.value.toString().trim() !== '') ||
        (item.dateValue && item.dateValue.toString().trim() !== '')
    );
    console.log(this.filters)
    this.tableLists = []
    this.ordersService
      .getDraftJobs(this.filters, this.pageNumber, this.pageSize, this.sortingCol, this.direction)
      .subscribe((data: any) => {
        if (data) {
          this.tableLists = data?.responseObject?.content;
          this.totalCount = data?.responseObject?.totalElements;
          // this.tableLists = this.tableLists.filter((el: any) => el.status === 'Draft');

          // console.log(this.tableLists)
          this.selectedData = []

        }
      }, err => {
        // console.log(err);
        this.totalCount = 0
        this.tableLists = []
      });
  }

  getListExportApi = (params: any): Observable<any> => {
    const {
      filters = {}, pageNumber = 0, pageSize = 250, sortingCol = 'id',
      direction = 'DESC'
    } = params;

    return this.ordersService.getOrders(
      filters, pageNumber, pageSize, sortingCol, direction
    );
  };

  onFilterChange(event: any) {
    console.log("................>>>",event)
    if (event) {
      this.filters = event
      this.getList()
    }
  }

  onResetFilters() {
    this.filters = []
    this.getList()
  }

  paginate(event: any) {
    this.pageNumber = event.pageIndex
    this.pageSize = event.pageSize
    this.currentPage = event.pageIndex
    this.getList()
  }

  onSortChange(event: { columnKey: string, sortOrder: 'ASC' | 'DESC' }): void {
    this.sortingCol = event.columnKey
    this.direction = event.sortOrder
    this.getList()
  }

  onSelectedRowsChange(selectedRows: any[]) {
    const storedData = JSON.parse(localStorage.getItem('columnToExport') || '{}');

    this.columnsToExport = storedData['budget'] ?? this.columnsToExport;

    this.selectedRows = selectedRows;
    this.selectedData = selectedRows;

    if (this.downloadExcel) {
      this.downloadExcel.data = [...selectedRows];
    } else {
      console.error('DownloadExcelComponent is not initialized.');
    }
  }

  addBudget(type: any) {
    this.ref = this.dialogService.open(AddordersComponent, {
      header: `${type} Order`,
      data: type == 'Add' ? {} : {
        editData: this.selectedData,
        edit: this.editContation
      },
      width: '70vw',
      contentStyle: { overflow: 'auto', position: "top" },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log("resss", data)
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
      }
      this.getList()
    });
  }



  receiveDataEvent(data: any[]) {
    console.log(data)
    this.selectedData = data
  }
  editEvent() {
    this.editContation = true
    console.log(this.editContation)
    this.addBudget('Edit')
  }
  deleteEvent() {
    // const ids = Array.from(new Set(this.selectedData.map((item: any) => item.id))).join(',');
    // this.emsServices.deleteExpense(ids).subscribe((data: any) => {
    //   if(data){
    //     this.selectedData = [];
    //     this.getList();
    //     this.messageService.add({
    //       severity: 'success',
    //       summary: 'Success',
    //       detail: 'Expense Deleted successfully',
    //     });
    //   }
    //  },err => {
    //   this.tableLists = []
    //  });
  }

  duplicateEvent() {
    console.log(this.selectedData)
    const payload = {
      expenseCategoryId: this.selectedData[0].expenseCategoryId,
      expenseModeId: this.selectedData[0].expenseModeId,
      expenseName: this.selectedData[0].expenseName,
      status: this.selectedData[0].status,
    };
    //  this.emsServices.expenseAddOrUpdate(payload).subscribe((data: any) => {
    //   if(data){
    //    this.messageService.add({
    //      severity: 'success',
    //      summary: 'Success',
    //      detail: 'Expense added successfully',
    //    });
    //    this.getList();
    //    this.selectedData = [];
    //   }
    //  });
  }


  upload(url: any, params: any) {
    this.tabService.addTab({
      label: 'Upload', path: url,
      fullPath: '',
      filterData: [],
      // pageNumber: 0,
      // pageSize: 10
    });
    this.router.navigate([url], { queryParams: params })
  }

}
